/***********************************************************************************************************************
* This file is auto-generated. If you have an issue, please create a GitHub issue.                                     *
***********************************************************************************************************************/

import {ShopifyRestResources} from '../../types';

import {AbandonedCheckout} from './abandoned_checkout';
import {AccessScope} from './access_scope';
import {AndroidPayKey} from './android_pay_key';
import {ApplePayCertificate} from './apple_pay_certificate';
import {ApplicationCharge} from './application_charge';
import {ApplicationCredit} from './application_credit';
import {Article} from './article';
import {Asset} from './asset';
import {AssignedFulfillmentOrder} from './assigned_fulfillment_order';
import {Balance} from './balance';
import {Blog} from './blog';
import {CancellationRequest} from './cancellation_request';
import {CarrierService} from './carrier_service';
import {Checkout} from './checkout';
import {Collect} from './collect';
import {Collection} from './collection';
import {CollectionListing} from './collection_listing';
import {Comment} from './comment';
import {Country} from './country';
import {Currency} from './currency';
import {CustomCollection} from './custom_collection';
import {Customer} from './customer';
import {CustomerAddress} from './customer_address';
import {DeprecatedApiCall} from './deprecated_api_call';
import {DiscountCode} from './discount_code';
import {Dispute} from './dispute';
import {DisputeEvidence} from './dispute_evidence';
import {DisputeFileUpload} from './dispute_file_upload';
import {DraftOrder} from './draft_order';
import {Event} from './event';
import {Fulfillment} from './fulfillment';
import {FulfillmentEvent} from './fulfillment_event';
import {FulfillmentOrder} from './fulfillment_order';
import {FulfillmentRequest} from './fulfillment_request';
import {FulfillmentService} from './fulfillment_service';
import {GiftCard} from './gift_card';
import {GiftCardAdjustment} from './gift_card_adjustment';
import {Image} from './image';
import {InventoryItem} from './inventory_item';
import {InventoryLevel} from './inventory_level';
import {Location} from './location';
import {LocationsForMove} from './locations_for_move';
import {MarketingEvent} from './marketing_event';
import {Metafield} from './metafield';
import {MobilePlatformApplication} from './mobile_platform_application';
import {Order} from './order';
import {OrderRisk} from './order_risk';
import {Page} from './page';
import {Payment} from './payment';
import {PaymentGateway} from './payment_gateway';
import {PaymentTransaction} from './payment_transaction';
import {Payout} from './payout';
import {Policy} from './policy';
import {PriceRule} from './price_rule';
import {Product} from './product';
import {ProductListing} from './product_listing';
import {ProductResourceFeedback} from './product_resource_feedback';
import {Province} from './province';
import {RecurringApplicationCharge} from './recurring_application_charge';
import {Redirect} from './redirect';
import {Refund} from './refund';
import {Report} from './report';
import {ResourceFeedback} from './resource_feedback';
import {ScriptTag} from './script_tag';
import {ShippingZone} from './shipping_zone';
import {Shop} from './shop';
import {SmartCollection} from './smart_collection';
import {StorefrontAccessToken} from './storefront_access_token';
import {TenderTransaction} from './tender_transaction';
import {Theme} from './theme';
import {Transaction} from './transaction';
import {UsageCharge} from './usage_charge';
import {User} from './user';
import {Variant} from './variant';
import {Webhook} from './webhook';

export interface RestResources extends ShopifyRestResources {
  AbandonedCheckout: typeof AbandonedCheckout;
  AccessScope: typeof AccessScope;
  AndroidPayKey: typeof AndroidPayKey;
  ApplePayCertificate: typeof ApplePayCertificate;
  ApplicationCharge: typeof ApplicationCharge;
  ApplicationCredit: typeof ApplicationCredit;
  Article: typeof Article;
  Asset: typeof Asset;
  AssignedFulfillmentOrder: typeof AssignedFulfillmentOrder;
  Balance: typeof Balance;
  Blog: typeof Blog;
  CancellationRequest: typeof CancellationRequest;
  CarrierService: typeof CarrierService;
  Checkout: typeof Checkout;
  Collect: typeof Collect;
  Collection: typeof Collection;
  CollectionListing: typeof CollectionListing;
  Comment: typeof Comment;
  Country: typeof Country;
  Currency: typeof Currency;
  CustomCollection: typeof CustomCollection;
  Customer: typeof Customer;
  CustomerAddress: typeof CustomerAddress;
  DeprecatedApiCall: typeof DeprecatedApiCall;
  DiscountCode: typeof DiscountCode;
  Dispute: typeof Dispute;
  DisputeEvidence: typeof DisputeEvidence;
  DisputeFileUpload: typeof DisputeFileUpload;
  DraftOrder: typeof DraftOrder;
  Event: typeof Event;
  Fulfillment: typeof Fulfillment;
  FulfillmentEvent: typeof FulfillmentEvent;
  FulfillmentOrder: typeof FulfillmentOrder;
  FulfillmentRequest: typeof FulfillmentRequest;
  FulfillmentService: typeof FulfillmentService;
  GiftCard: typeof GiftCard;
  GiftCardAdjustment: typeof GiftCardAdjustment;
  Image: typeof Image;
  InventoryItem: typeof InventoryItem;
  InventoryLevel: typeof InventoryLevel;
  Location: typeof Location;
  LocationsForMove: typeof LocationsForMove;
  MarketingEvent: typeof MarketingEvent;
  Metafield: typeof Metafield;
  MobilePlatformApplication: typeof MobilePlatformApplication;
  Order: typeof Order;
  OrderRisk: typeof OrderRisk;
  Page: typeof Page;
  Payment: typeof Payment;
  PaymentGateway: typeof PaymentGateway;
  PaymentTransaction: typeof PaymentTransaction;
  Payout: typeof Payout;
  Policy: typeof Policy;
  PriceRule: typeof PriceRule;
  Product: typeof Product;
  ProductListing: typeof ProductListing;
  ProductResourceFeedback: typeof ProductResourceFeedback;
  Province: typeof Province;
  RecurringApplicationCharge: typeof RecurringApplicationCharge;
  Redirect: typeof Redirect;
  Refund: typeof Refund;
  Report: typeof Report;
  ResourceFeedback: typeof ResourceFeedback;
  ScriptTag: typeof ScriptTag;
  ShippingZone: typeof ShippingZone;
  Shop: typeof Shop;
  SmartCollection: typeof SmartCollection;
  StorefrontAccessToken: typeof StorefrontAccessToken;
  TenderTransaction: typeof TenderTransaction;
  Theme: typeof Theme;
  Transaction: typeof Transaction;
  UsageCharge: typeof UsageCharge;
  User: typeof User;
  Variant: typeof Variant;
  Webhook: typeof Webhook;
}

export const restResources: RestResources = {
  AbandonedCheckout,
  AccessScope,
  AndroidPayKey,
  ApplePayCertificate,
  ApplicationCharge,
  ApplicationCredit,
  Article,
  Asset,
  AssignedFulfillmentOrder,
  Balance,
  Blog,
  CancellationRequest,
  CarrierService,
  Checkout,
  Collect,
  Collection,
  CollectionListing,
  Comment,
  Country,
  Currency,
  CustomCollection,
  Customer,
  CustomerAddress,
  DeprecatedApiCall,
  DiscountCode,
  Dispute,
  DisputeEvidence,
  DisputeFileUpload,
  DraftOrder,
  Event,
  Fulfillment,
  FulfillmentEvent,
  FulfillmentOrder,
  FulfillmentRequest,
  FulfillmentService,
  GiftCard,
  GiftCardAdjustment,
  Image,
  InventoryItem,
  InventoryLevel,
  Location,
  LocationsForMove,
  MarketingEvent,
  Metafield,
  MobilePlatformApplication,
  Order,
  OrderRisk,
  Page,
  Payment,
  PaymentGateway,
  PaymentTransaction,
  Payout,
  Policy,
  PriceRule,
  Product,
  ProductListing,
  ProductResourceFeedback,
  Province,
  RecurringApplicationCharge,
  Redirect,
  Refund,
  Report,
  ResourceFeedback,
  ScriptTag,
  ShippingZone,
  Shop,
  SmartCollection,
  StorefrontAccessToken,
  TenderTransaction,
  Theme,
  Transaction,
  UsageCharge,
  User,
  Variant,
  Webhook,
};